import type { LotGarageHanding } from "api-types/lots/lotTypes";
import type { LotStatus } from "api-types/modelTypes";

interface LotStatusOption {
  value: LotStatus;
  label: string;
}

export const LotStatusOptions: LotStatusOption[] = [
  { value: "unavailable", label: "Unavailable" },
  { value: "available", label: "Available" },
  { value: "pending", label: "Pending" },
  { value: "sold", label: "Sold" },
  { value: "closed", label: "Closed" },
];

/** Stands in for the unset direction. Not "", which Radix reserves for "no selection". */
export const LOT_GARAGE_HANDING_DEFAULT = "default";

interface LotGarageHandingOption {
  value: LotGarageHanding | typeof LOT_GARAGE_HANDING_DEFAULT;
  label: string;
}

export const LotGarageHandingOptions: LotGarageHandingOption[] = [
  { value: LOT_GARAGE_HANDING_DEFAULT, label: "Default" },
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
];
